import React from 'react';
import classNames from 'classnames/bind';
import empty from '../../../assets/images/Emty.png'
import styles from './SearchFail.module.css'
import { useTranslation } from 'react-i18next';


const cx = classNames.bind(styles)
const SearchFail = ({ title }) => {
    const { t } = useTranslation()
    return (
        <div className={cx('content')}>
            <img src={empty} alt={t("location.noResultAlt")} />
            <p className={cx('description')}>{title ? title : t("location.noResult")}</p>
        </div>
    );
};

export default SearchFail;